"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getScheduleView = getScheduleView;
exports.getAllScheduleView = getAllScheduleView;
exports.getScheduleItem = getScheduleItem;
exports.putScheduleItem = putScheduleItem;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _environment = require("../environment");

var _utils = require("../utils");

var _internals = require("../utils/internals");

var _sortingFiltering = require("../utils/sorting-filtering");

var _session = require("../session");

function getScheduleView(_x) {
  return _getScheduleView.apply(this, arguments);
}

function _getScheduleView() {
  _getScheduleView = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(options) {
    return _regenerator.default.wrap(function _callee4$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", _promise.default.all([(0, _environment.getRoute)('CoreServices'), options.companyId ? options.companyId : (0, _session.getCompanyId)()]).then(function (_ref2) {
              var _context2;

              var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
                  base = _ref3[0],
                  companyId = _ref3[1];

              return (0, _concat.default)(_context2 = "".concat(base, "/v3/companies/")).call(_context2, companyId, "/schedule-item-views");
            }).then(function (base) {
              var url = new _url.default(base);
              (0, _sortingFiltering.applyFilter)(url, options);
              (0, _sortingFiltering.applyPaging)(url, options);

              if (options.employeeId) {
                url.searchParams.append('employeeId', options.employeeId);
              }

              if (options.frp) {
                url.searchParams.append('frp', options.frp);
              }

              if (options.filterByApplicationId) {
                url.searchParams.append('filterByApplicationId', options.filterByApplicationId);
              }

              if (options.expand) {
                url.searchParams.append('expand', options.expand);
              }

              return url.href;
            }).then( /*#__PURE__*/function () {
              var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(url) {
                return _regenerator.default.wrap(function _callee2$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x6) {
                return _ref4.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(response) {
                return _regenerator.default.wrap(function _callee3$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        return _context4.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x7) {
                return _ref5.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee4);
  }));
  return _getScheduleView.apply(this, arguments);
}

function getAllScheduleView(options) {
  return (0, _sortingFiltering.pagingAsyncIterator)( /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(startIndex) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", getScheduleView((0, _objectSpread2.default)((0, _objectSpread2.default)({}, options), {}, {
                startIndex: startIndex
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x2) {
      return _ref.apply(this, arguments);
    };
  }());
}

function getScheduleItem(_x3) {
  return _getScheduleItem.apply(this, arguments);
}

function _getScheduleItem() {
  _getScheduleItem = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(options) {
    return _regenerator.default.wrap(function _callee7$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt("return", _promise.default.all([(0, _environment.getRoute)('CoreServices'), options.companyId ? options.companyId : (0, _session.getCompanyId)()]).then(function (_ref6) {
              var _context6, _context7;

              var _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
                  base = _ref7[0],
                  companyId = _ref7[1];

              return (0, _concat.default)(_context6 = (0, _concat.default)(_context7 = "".concat(base, "/v6/companies/")).call(_context7, companyId, "/schedule-items/")).call(_context6, options.scheduleItemId);
            }).then(function (base) {
              var url = new _url.default(base);

              if (options.frp) {
                url.searchParams.append('frp', options.frp);
              }

              if (options.expand) {
                url.searchParams.append('expand', options.expand);
              }

              return url.href;
            }).then( /*#__PURE__*/function () {
              var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(url) {
                return _regenerator.default.wrap(function _callee5$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        return _context8.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee5);
              }));

              return function (_x8) {
                return _ref8.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(response) {
                return _regenerator.default.wrap(function _callee6$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        return _context9.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee6);
              }));

              return function (_x9) {
                return _ref9.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee7);
  }));
  return _getScheduleItem.apply(this, arguments);
}

function putScheduleItem(_x4, _x5) {
  return _putScheduleItem.apply(this, arguments);
}

function _putScheduleItem() {
  _putScheduleItem = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(options, body) {
    return _regenerator.default.wrap(function _callee10$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt("return", _promise.default.all([(0, _environment.getRoute)('CoreServices'), options.companyId ? options.companyId : (0, _session.getCompanyId)()]).then(function (_ref10) {
              var _context11, _context12;

              var _ref11 = (0, _slicedToArray2.default)(_ref10, 2),
                  base = _ref11[0],
                  companyId = _ref11[1];

              return (0, _concat.default)(_context11 = (0, _concat.default)(_context12 = "".concat(base, "/v6/companies/")).call(_context12, companyId, "/schedule-items/")).call(_context11, options.scheduleItemId);
            }).then( /*#__PURE__*/function () {
              var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(url) {
                return _regenerator.default.wrap(function _callee8$(_context13) {
                  while (1) {
                    switch (_context13.prev = _context13.next) {
                      case 0:
                        return _context13.abrupt("return", fetch(url, {
                          method: 'PUT',
                          body: (0, _stringify.default)(body),
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context13.stop();
                    }
                  }
                }, _callee8);
              }));

              return function (_x10) {
                return _ref12.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(response) {
                return _regenerator.default.wrap(function _callee9$(_context14) {
                  while (1) {
                    switch (_context14.prev = _context14.next) {
                      case 0:
                        return _context14.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context14.stop();
                    }
                  }
                }, _callee9);
              }));

              return function (_x11) {
                return _ref13.apply(this, arguments);
              };
            }()).then(function (responseBody) {
              return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, body), responseBody);
            }));

          case 1:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee10);
  }));
  return _putScheduleItem.apply(this, arguments);
}
